import React from "react";

export const Award = (props) => {
  return (
    <div id="award" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <h2>Best Young Researcher Contribution Award</h2>
        </div>
        <div className="col-md-8 col-md-offset-2 text-justify-xs">
          <div className="award-text">
            <p>
              Sponsored by the
              <a
                href="https://www.mdpi.com/journal/acoustics"
                target="_blank"
                rel="noopener noreferrer"
              >
                MDPI Acoustics journal
              </a>{" "}
            </p>
            <br></br>
            <img src={"img/sponsors/10.png"} alt="..." className="award-img" />
            <br></br>
            <br></br>
            <p>
              The Best Young Researcher Contribution Award was given to two
              participants. Each awarded participant was granted the amount of
              300 EUR.
            </p>
            <br></br>
            <br></br>
            <p>
              Based on the evaluation of both the written papers and the oral
              presentations by a panel of judges, the Award was given to the
              following recipients:
            </p>
            <br></br>
            <h4>Josip Skledar</h4>
            <p className="text-center">
              University of Zagreb, Faculty of Electrical Engineering and
              Computing, Zagreb, Croatia
            </p>
            <br></br>
            <h4>Teo Poldrugovac</h4>
            <p className="text-center">
              University of Zagreb, Faculty of Humanities and Social Sciences,
              Zagreb, Croatia
            </p>
            <br></br>
            <br></br>
          </div>
        </div>
      </div>
    </div>
  );
};
